import dayjs from 'dayjs'
import { DurationUnitsObjectType } from 'dayjs/plugin/duration'
import { IcsCalendar } from 'ts-ics'

import { useLocalization } from '@/shared/composables/localization'

import { TIME_FORMAT, BIRTH_DAY_DATE_TIME_FORMAT } from '../constants/date-time'

export const getScheduleEventDisplayName = (summary: string | undefined, fallback: string): string => {
  const trimmedSummary = summary?.trim()
  return trimmedSummary ? trimmedSummary : fallback
}

export const scheduleToTextMessage = (schedule: IcsCalendar): string => {
  const { t } = useLocalization()
  const { events = [] } = schedule

  if (events.length === 0) {
    return ''
  }

  const { start, duration } = events[0] ?? { start: { date: '' }, duration: { seconds: 0, minutes: 0, hours: 0 } as DurationUnitsObjectType }

  if (!start.date || !duration) {
    return ''
  }

  const { seconds = 0, minutes = 0, hours = 0 } = duration
  const durationUnits: DurationUnitsObjectType = {
    seconds,
    minutes,
    hours,
  }

  const durationTime = dayjs.duration(durationUnits).format(TIME_FORMAT)
  return `${dayjs(start.date).format(BIRTH_DAY_DATE_TIME_FORMAT)}. ${t('common.duration')} — ${durationTime}`
}
